module.exports = __webpack_public_path__ + "img/border_bubble.a903c51a.svg";